<template>
	<div>
		<div class="row hidden-xs">
			<div class="col pt-0">
				<bread-crumbs
					:bread-crumbs="breadCrumbs"
					:current-title="currentTitle"
					class="breadcrumbstyle py-2"
				/>
			</div>
		</div>

		<div class="row">
			<div class="col">
				<h1 class="page-header">
					<translate>{{ currentTitle }}</translate>
				</h1>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FrontofficeHeader',
	props: {
		breadCrumbs: {
			type: Object,
			required: false,
			default: () => ({
			}),
		},
		currentTitle: {
			type: String,
			required: true,
		},
	},
};
</script>

<style scoped>
	.breadcrumbstyle {
		background-color: #eeeeee;
		border-radius: 4px;
	}
</style>
